import { useTranslation } from 'react-i18next';

import { typeTraitementEnum } from '../../Expert/CompleterProfile/DonneesPersonnelsExpert';
import SocieteGeneralisation from '../../Expert/Profile/SocieteGeneralisation';
import SideBarAddExpert from './SideBarAddExpert';

function AjouterExpertStep4() {
    const { i18n } = useTranslation();

    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignItems: 'flex-start',alignSelf:'stretch',gap:'24px'}}>
                <div className='frame5Profile'>{i18n.t('Gestion des Experts')} &gt;<span style={{color:'rgba(39, 45, 60, 1)'}}>{i18n.t('Ajouter un Expert')} </span> </div>
                <div style={{display:'flex',flexDirection:'row',alignSelf:'stretch',gap:'24px'}}>
                    <SideBarAddExpert/>
                    <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:'80%',alignItems: 'center',gap:'24px'}}>
                        <SocieteGeneralisation typeTraitement={typeTraitementEnum.ADMIN_ADD_EXPERT} />
                    </div>
                </div>
            </div>

        </>
    );
}
export default AjouterExpertStep4;